import {getCurrentBreakpointParams} from "./get-current-breakpoint-params";
import {isInViewport} from "./is-In-viewport";
import {throttle} from "./throttle";
import {getEventDelay} from "./get-event-delay";

export function resourcesSection() {
    let win = window;
    let $win = $(win);
    let swiperButtonPrefix = ".swiper-button-";
    let withoutSliderInstanceClassName = "without-slider";
    let sliderWrapClassName = "resources-section";
    let sliderWrapSelector = "." + sliderWrapClassName;
    let sliderWrap = $(sliderWrapSelector);
    let slidersLength = sliderWrap.length;
    let counterInitializedSliders = 0;
    let isAllSlidersReady = false;
    let sliderInstanceName = "sliderInstance";
    let sliderDataName = "sliderData";
    let eventScrollName = "scroll";
    let eventScrollDelay = getEventDelay(eventScrollName);

    function getDefaultSliderOptions(curSliderWrap) {
        return {
            watchOverflow: true,
            //watchSlidesVisibility: true,
            slidesPerView: 2,
            spaceBetween: 8,
            navigation: {
                nextEl: curSliderWrap.find(swiperButtonPrefix + "next"),
                prevEl: curSliderWrap.find(swiperButtonPrefix + "prev"),
            },
        };
    }

    function getBreakpointOptions(curSliderWrap) {
        return {
            0: {
                slider: {
                    slidesPerView: 1
                }
            },
            568: {
                slider: {
                    spaceBetween: 10,
                }
            },
            1200: {
                slider: {
                    spaceBetween: 30,
                }
            },
            1800: {
                slider: {
                    spaceBetween: 44,
                }
            }
        };
    }

    function setIsAllSlidersReady() {
        isAllSlidersReady = counterInitializedSliders == slidersLength;
    }

    function initSliders(isScrollEvent, isInitEvent) {
        isScrollEvent = typeof (isScrollEvent) === "boolean" ? isScrollEvent : false;

        if (!(isScrollEvent && isAllSlidersReady)) {  //if scroll event and all the sliders init
            let winWidth = parseInt(win.innerWidth);

            sliderWrap.each(function () {
                let curSliderWrap = $(this);
                let isInit = curSliderWrap.hasClass("init");
                let initSlider = function () {

                    let curSlider = curSliderWrap.find(".swiper-container");
                    let curBreakpointParams = getCurrentBreakpointParams(winWidth, getBreakpointOptions(curSliderWrap), curSliderWrap);
                    let isEqualBreakpoint = curSlider.data("sliderBreakpoint") == curBreakpointParams.breakpoint;

                    if (!isEqualBreakpoint) {
                        let curSliderData = curSlider.data(sliderDataName);
                        let curSliderOptions = $.extend(true, {}, getDefaultSliderOptions(curSliderWrap), curBreakpointParams.options.slider);
                        let curSliderInstance = curSlider.data(sliderInstanceName);

                        if (!curSliderInstance) {
                            curSlider.data(sliderInstanceName, true);
                        }

                        //is has instance destroy
                        if (curSliderData) {
                            curSliderData.destroy(true, true);
                        }

                        curSlider.data("sliderBreakpoint", curBreakpointParams.breakpoint);

                        let curSlides = curSlider.find(".swiper-slide");

                        if (!curSliderOptions.isDestroy && curSlides.length > curSliderOptions.slidesPerView) {
                            curSlider.data(sliderDataName, new Swiper(curSlider, curSliderOptions));
                            curSliderWrap.removeClass(withoutSliderInstanceClassName);

                        } else {
                            curSliderWrap.addClass(withoutSliderInstanceClassName);
                        }
                    }
                };

                if (isInit) {
                    if (!isScrollEvent) {
                        initSlider();
                    }
                } else {
                    if (isInViewport(curSliderWrap, isInitEvent ? 0 : 150)) {
                        curSliderWrap.addClass("init");
                        counterInitializedSliders++;
                        setIsAllSlidersReady();
                        initSlider();
                    }
                }
            });
        }
    }

    /*function updateSliders() {
     sliderWrap = $(sliderWrapSelector);
     slidersLength = sliderWrap.length;
     counterInitializedSliders = sliderWrap.filter('.init').length;
     setIsAllSlidersReady();
   }*/

    $(document).ready(function () {
        initSliders(false, true);
    });

    $win.on(eventScrollName, throttle(function () {
        initSliders(true);
    }, eventScrollDelay));

    ["resize", "orientationchange"].map(function (item) {
        let eventDelay = getEventDelay(item);
        $win.on(item, throttle(initSliders, eventDelay));
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resources-section.js